import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/exhibition-area',
    name: 'exhibitionArea',
    component: () => import('../components/exhibitionArea.vue')
  },
  // {
  //   path: '/award',
  //   name: 'Award',
  //   component: () => import('../views/Award.vue')
  // },
  // {
  //   path: '/picture-book',
  //   name: 'PictureBook',
  //   component: () => import('../views/PictureBook.vue')
  // },
  // {
  //   path: '/creative',
  //   name: 'Creative',
  //   component: () => import('../views/Creative.vue')
  // },
  // {
  //   path: '/heritage',
  //   name: 'Heritage',
  //   component: () => import('../views/Heritage.vue')
  // },
  {
    path: '/exhibits',
    name: 'Exhibits',
    component: () => import('../views/exhibition.vue'),
  },
  {
    path: '/exhibits/detail/:id',
    name: 'ExhibitDetail',
    component: () => import('../views/ExhibitDetail.vue')
  },
  {
    path: '/exhibitors',
    name: 'Exhibitors',
    component: () => import('../views/Exhibitors.vue')
  },
  {
    path: '/sponsors',
    name: 'Sponsors',
    component: () => import('../views/Sponsors.vue')
  },
  // {
  //   path: '/exhibition',
  //   name: 'exhibition',
  //   component: () => import('../views/exhibition.vue')
  // },
  {
   path: '/detail/:id', 
   name: 'detail',
   component: () => import('../components/detail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 全局前置守卫，确保每次路由跳转后页面都滚动到顶部
router.beforeEach((to, from, next) => {
  // 继续路由导航
  next()
})

// 全局后置钩子，路由跳转完成后滚动到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router